import { gql } from "@apollo/client";

const REQUEST_PRICE_UPDATE = gql`
  mutation createRequest($inputs: [CreateRequestInput!]!) {
    createRequest(inputs: $inputs) {
      id
      modelId
      modelType
    }
  }
`;

const SCRAPE_ONLINE_PALENGKE = gql`
  mutation scrapeDataFromOnlinePalenke($pages: Float!) {
    scrapeDataFromOnlinePalenke(pages: $pages) {
      id
      name
      price
      source
    }
  }
`;
const SCRAPE_PALENGKE_SENTRAL = gql`
  mutation scrapeDataFromPalenkeSentral($pages: Float!) {
    scrapeDataFromPalenkeSentral(pages: $pages) {
      id
      name
      price
      source
    }
  }
`;

export {
  REQUEST_PRICE_UPDATE,
  SCRAPE_ONLINE_PALENGKE,
  SCRAPE_PALENGKE_SENTRAL,
};
